import { FormBase } from "core/components";

export default class TrackingCaseEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "reference",
                    label: "TRACKING_CASE.EDIT.REFERENCE_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.REFERENCE_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "facilityId",
                    label: "TRACKING_CASE.EDIT.FACILITY_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.FACILITY_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "caseStatusId",
                    label: "TRACKING_CASE.EDIT.CASE_STATUS_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.CASE_STATUS_PLACEHOLDER",
                    rules: "string"
                },
                {
                    name: "itemCategoryId",
                    label: "TRACKING_CASE.EDIT.ITEM_CATEGORY_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.ITEM_CATEGORY_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "patientId",
                    label: "TRACKING_CASE.EDIT.PATIENT_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.PATIENT_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "payorSource",
                    label: "TRACKING_CASE.EDIT.PAYORE_SOURCE_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.PAYORE_SOURCE_PLACEHOLDER",
                    rules: "required",
                },
                {
                    name: "validFrom",
                    label: "TRACKING_CASE.EDIT.VALID_FROM_LABEL",
                    rules: "required"
                },
                {
                    name: "validTo",
                    label: "TRACKING_CASE.EDIT.VALID_TO_LABEL",
                },
                {
                    name: "trackingCaseProducts",
                    label: "TRACKING_CASE.EDIT.PRODUCTS_LABEL",
                    placeholder: "TRACKING_CASE.EDIT.PRODUCTS_PLACEHOLDER",
                    rules: "array"
                },
                {
                    name: "docCode",
                    rules: "string"
                },
            ],
        };
    }
}         
